import { sendEvent } from './sendEvent';

export const goToRequestReferral = () => {
  sendEvent('Medicine', 'ExpiredMedicineButtons');
  window.open(process.env.REACT_APP_REQUEST_REFERRAL, '_blank');
};
